import { useEffect, useState } from 'react';
import { Modal } from '../../../components/Modal';
import { ManualInput } from '../components/AddBookForm';
import { BookCreate, BookType } from '../api/types';
import { toast } from 'react-toastify';
import { Button } from '../../../components/Button';
import { useUpdateBookMutation } from '../api/booksApi';

type EditModalProps = {
  bookToEdit: BookType | null;
  onCloseModal: () => void;
};

export const useEditModal = ({ bookToEdit, onCloseModal }: EditModalProps) => {
  const [editBook] = useUpdateBookMutation();
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [bookCreate, setBookCreate] = useState<BookCreate>({
    cover: null,
    back: null,
    title: '',
    author_name: '',
    price: '',
    category_name: '',
    publisher_name: '',
    synopsis: ''
  });

  const onValueChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (!bookCreate) return;
    const { name, value } = e.target;
    console.log(name, value);
    setBookCreate({ ...bookCreate, [name]: value });
  };

  const handleImageChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    type: 'back' | 'cover'
  ) => {
    if (!bookCreate) return;
    const image = event.target.files?.[0];
    if (!image) {
      toast('Error uploading image', { type: 'error' });
      return;
    }
    setBookCreate({ ...bookCreate, [type]: image });
  };

  const isButtonDisabled =
    bookToEdit?.title === bookCreate.title &&
    bookToEdit?.author === bookCreate.author_name &&
    bookToEdit?.category === bookCreate.category_name &&
    bookToEdit?.price === String(bookCreate.price) &&
    bookToEdit?.publisher === bookCreate.publisher_name &&
    bookToEdit?.synopsis === bookCreate.synopsis;

  const onSave = async () => {
    try {
      const formData = new FormData();

      if (bookCreate.cover instanceof File) {
        formData.append('cover', bookCreate.cover);
      }
      if (bookCreate.back instanceof File) {
        formData.append('back', bookCreate.back);
      }

      const values = Object.entries(bookCreate);
      console.log(bookCreate);

      for (const [key, value] of values) {
        if (key === 'cover' || key === 'back') continue;
        if (value) {
          console.log(key, value);
          formData.append(key, String(value));
        }
      }

      await editBook({ bookId: bookToEdit?.id || '', formData }).unwrap();
      toast('Book updated successfully', { type: 'success' });
      onCloseModal();
    } catch (err) {
      console.log(err);
    }
  };

  const EditModal = (
    <Modal isOpen={isEditModalOpen} onClose={onCloseModal}>
      {bookCreate && (
        <ManualInput
          values={bookCreate}
          handleImageChange={handleImageChange}
          onFieldChange={onValueChange}
        />
      )}
      <div className="flex gap-2 mt-4">
        <Button variant="secondary" onClick={onCloseModal}>
          Cancel
        </Button>
        <Button disabled={isButtonDisabled} onClick={onSave}>
          Save
        </Button>
      </div>
    </Modal>
  );

  useEffect(() => {
    if (bookToEdit) {
      console.log(bookToEdit.title);
      setBookCreate((prev) => ({
        ...prev,
        cover: bookToEdit.cover,
        back: bookToEdit.back,
        title: bookToEdit.title,
        author_name: bookToEdit.author,
        price: String(bookToEdit.price),
        category_name: bookToEdit.category || '',
        publisher_name: bookToEdit.publisher || '',
        synopsis: bookToEdit.synopsis || '',
        year: bookToEdit.year || undefined,
        pages: bookToEdit.pages || undefined
      }));
      setIsEditModalOpen(true);
    } else {
      setIsEditModalOpen(false);
    }
  }, [bookToEdit]);
  return { EditModal };
};
